!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactPaginate = t(require("react")) : e.ReactPaginate = t(e.React);
}(this, function (__WEBPACK_EXTERNAL_MODULE__98__) {
  return function () {
    var __webpack_modules__ = {
      759: function _(e, t, a) {
        "use strict";

        a.d(t, {
          Z: function Z() {
            return c;
          }
        });

        var r,
            o = a(98),
            _ = a.n(o),
            n = a(697),
            i = a.n(n);

        function s() {
          return s = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var a = arguments[t];

              for (var r in a) {
                Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
              }
            }

            return e;
          }, s.apply(this, arguments);
        }

        e = a.hmd(e), (r = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r(e), "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature;

        var l = function l(e) {
          var t = e.breakLabel,
              a = e.breakClassName,
              r = e.breakLinkClassName,
              o = e.breakHandler,
              n = e.getEventListener,
              i = a || "break";
          return _().createElement("li", {
            className: i
          }, _().createElement("a", s({
            className: r,
            role: "button",
            tabIndex: "0",
            onKeyPress: o
          }, n(o)), t));
        };

        l.propTypes = {
          breakLabel: i().oneOfType([i().string, i().node]),
          breakClassName: i().string,
          breakLinkClassName: i().string,
          breakHandler: i().func.isRequired,
          getEventListener: i().func.isRequired
        };
        var p = l;
        var c = p;
        var d, u;
        (d = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && (d.register(l, "BreakView", "/home/yoan/work/oss/react-paginate/react_components/BreakView.js"), d.register(p, "default", "/home/yoan/work/oss/react-paginate/react_components/BreakView.js")), (u = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && u(e);
      },
      770: function _(e, t, a) {
        "use strict";

        a.d(t, {
          Z: function Z() {
            return c;
          }
        });

        var r,
            o = a(98),
            _ = a.n(o),
            n = a(697),
            i = a.n(n);

        function s() {
          return s = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var a = arguments[t];

              for (var r in a) {
                Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
              }
            }

            return e;
          }, s.apply(this, arguments);
        }

        e = a.hmd(e), (r = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r(e), "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature;

        var l = function l(e) {
          var t = e.pageClassName,
              a = e.pageLinkClassName,
              r = e.page,
              o = e.selected,
              n = e.activeClassName,
              i = e.activeLinkClassName,
              l = e.getEventListener,
              p = e.pageSelectedHandler,
              c = e.href,
              d = e.extraAriaContext,
              u = e.pageLabelBuilder,
              f = e.rel,
              g = e.ariaLabel || "Page " + r + (d ? " " + d : ""),
              P = null;
          return o && (P = "page", g = e.ariaLabel || "Page " + r + " is your current page", t = void 0 !== t ? t + " " + n : n, void 0 !== a ? void 0 !== i && (a = a + " " + i) : a = i), _().createElement("li", {
            className: t
          }, _().createElement("a", s({
            rel: f,
            role: c ? void 0 : "button",
            className: a,
            href: c,
            tabIndex: o ? "-1" : "0",
            "aria-label": g,
            "aria-current": P,
            onKeyPress: p
          }, l(p)), u(r)));
        };

        l.propTypes = {
          pageSelectedHandler: i().func.isRequired,
          selected: i().bool.isRequired,
          pageClassName: i().string,
          pageLinkClassName: i().string,
          activeClassName: i().string,
          activeLinkClassName: i().string,
          extraAriaContext: i().string,
          href: i().string,
          ariaLabel: i().string,
          page: i().number.isRequired,
          getEventListener: i().func.isRequired,
          pageLabelBuilder: i().func.isRequired,
          rel: i().string
        };
        var p = l;
        var c = p;
        var d, u;
        (d = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && (d.register(l, "PageView", "/home/yoan/work/oss/react-paginate/react_components/PageView.js"), d.register(p, "default", "/home/yoan/work/oss/react-paginate/react_components/PageView.js")), (u = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && u(e);
      },
      214: function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.d(__webpack_exports__, {
          Z: function Z() {
            return PaginationBoxView;
          }
        });

        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98),
            react__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__),
            prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(697),
            prop_types__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__),
            _PageView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(770),
            _BreakView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(759),
            _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(923),
            enterModule;

        function _typeof(e) {
          return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, _typeof(e);
        }

        function _extends() {
          return _extends = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var a = arguments[t];

              for (var r in a) {
                Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
              }
            }

            return e;
          }, _extends.apply(this, arguments);
        }

        function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function _defineProperties(e, t) {
          for (var a = 0; a < t.length; a++) {
            var r = t[a];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function _createClass(e, t, a) {
          return t && _defineProperties(e.prototype, t), a && _defineProperties(e, a), e;
        }

        function _inherits(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && _setPrototypeOf(e, t);
        }

        function _setPrototypeOf(e, t) {
          return _setPrototypeOf = Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          }, _setPrototypeOf(e, t);
        }

        function _createSuper(e) {
          var t = _isNativeReflectConstruct();

          return function () {
            var a,
                r = _getPrototypeOf(e);

            if (t) {
              var o = _getPrototypeOf(this).constructor;

              a = Reflect.construct(r, arguments, o);
            } else a = r.apply(this, arguments);

            return _possibleConstructorReturn(this, a);
          };
        }

        function _possibleConstructorReturn(e, t) {
          if (t && ("object" === _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return _assertThisInitialized(e);
        }

        function _assertThisInitialized(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }

        function _isNativeReflectConstruct() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }

        function _getPrototypeOf(e) {
          return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, _getPrototypeOf(e);
        }

        function _defineProperty(e, t, a) {
          return t in e ? Object.defineProperty(e, t, {
            value: a,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = a, e;
        }

        module = __webpack_require__.hmd(module), enterModule = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0, enterModule && enterModule(module);

        var __signature__ = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default.signature : function (e) {
          return e;
        },
            PaginationBoxView = function (_Component) {
          _inherits(PaginationBoxView, _Component);

          var _super = _createSuper(PaginationBoxView);

          function PaginationBoxView(e) {
            var t, a;
            return _classCallCheck(this, PaginationBoxView), _defineProperty(_assertThisInitialized(t = _super.call(this, e)), "handlePreviousPage", function (e) {
              var a = t.state.selected;
              t.handleClick(e, null, a > 0 ? a - 1 : void 0, {
                isPrevious: !0
              });
            }), _defineProperty(_assertThisInitialized(t), "handleNextPage", function (e) {
              var a = t.state.selected,
                  r = t.props.pageCount;
              t.handleClick(e, null, a < r - 1 ? a + 1 : void 0, {
                isNext: !0
              });
            }), _defineProperty(_assertThisInitialized(t), "handlePageSelected", function (e, a) {
              if (t.state.selected === e) return t.callActiveCallback(e), void t.handleClick(a, null, void 0, {
                isActive: !0
              });
              t.handleClick(a, null, e);
            }), _defineProperty(_assertThisInitialized(t), "handlePageChange", function (e) {
              t.state.selected !== e && (t.setState({
                selected: e
              }), t.callCallback(e));
            }), _defineProperty(_assertThisInitialized(t), "getEventListener", function (e) {
              return _defineProperty({}, t.props.eventListener, e);
            }), _defineProperty(_assertThisInitialized(t), "handleClick", function (e, a, r) {
              var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
                  _ = o.isPrevious,
                  n = void 0 !== _ && _,
                  i = o.isNext,
                  s = void 0 !== i && i,
                  l = o.isBreak,
                  p = void 0 !== l && l,
                  c = o.isActive,
                  d = void 0 !== c && c;
              e.preventDefault ? e.preventDefault() : e.returnValue = !1;
              var u = t.state.selected,
                  f = t.props.onClick,
                  g = r;

              if (f) {
                var P = f({
                  index: a,
                  selected: u,
                  nextSelectedPage: r,
                  event: e,
                  isPrevious: n,
                  isNext: s,
                  isBreak: p,
                  isActive: d
                });
                if (!1 === P) return;
                Number.isInteger(P) && (g = P);
              }

              void 0 !== g && t.handlePageChange(g);
            }), _defineProperty(_assertThisInitialized(t), "handleBreakClick", function (e, a) {
              var r = t.state.selected;
              t.handleClick(a, e, r < e ? t.getForwardJump() : t.getBackwardJump(), {
                isBreak: !0
              });
            }), _defineProperty(_assertThisInitialized(t), "callCallback", function (e) {
              void 0 !== t.props.onPageChange && "function" == typeof t.props.onPageChange && t.props.onPageChange({
                selected: e
              });
            }), _defineProperty(_assertThisInitialized(t), "callActiveCallback", function (e) {
              void 0 !== t.props.onPageActive && "function" == typeof t.props.onPageActive && t.props.onPageActive({
                selected: e
              });
            }), _defineProperty(_assertThisInitialized(t), "getElementPageRel", function (e) {
              var a = t.state.selected,
                  r = t.props,
                  o = r.nextPageRel,
                  _ = r.prevPageRel,
                  n = r.selectedPageRel;
              return a - 1 === e ? _ : a === e ? n : a + 1 === e ? o : void 0;
            }), _defineProperty(_assertThisInitialized(t), "pagination", function () {
              var e = [],
                  a = t.props,
                  r = a.pageRangeDisplayed,
                  o = a.pageCount,
                  _ = a.marginPagesDisplayed,
                  n = a.breakLabel,
                  i = a.breakClassName,
                  s = a.breakLinkClassName,
                  l = t.state.selected;
              if (o <= r) for (var p = 0; p < o; p++) {
                e.push(t.getPageElement(p));
              } else {
                var c = r / 2,
                    d = r - c;
                l > o - r / 2 ? c = r - (d = o - l) : l < r / 2 && (d = r - (c = l));

                var u,
                    f,
                    g = function g(e) {
                  return t.getPageElement(e);
                },
                    P = [];

                for (u = 0; u < o; u++) {
                  var E = u + 1;
                  E <= _ || E > o - _ || u >= l - c && u <= l + (0 === l && r > 1 ? d - 1 : d) ? P.push({
                    type: "page",
                    index: u,
                    display: g(u)
                  }) : n && P.length > 0 && P[P.length - 1].display !== f && (r > 0 || _ > 0) && (f = react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_BreakView__WEBPACK_IMPORTED_MODULE_3__.Z, {
                    key: u,
                    breakLabel: n,
                    breakClassName: i,
                    breakLinkClassName: s,
                    breakHandler: t.handleBreakClick.bind(null, u),
                    getEventListener: t.getEventListener
                  }), P.push({
                    type: "break",
                    index: u,
                    display: f
                  }));
                }

                P.forEach(function (t, a) {
                  var r = t;
                  "break" === t.type && P[a - 1] && "page" === P[a - 1].type && P[a + 1] && "page" === P[a + 1].type && P[a + 1].index - P[a - 1].index <= 2 && (r = {
                    type: "page",
                    index: t.index,
                    display: g(t.index)
                  }), e.push(r.display);
                });
              }
              return e;
            }), void 0 !== e.initialPage && void 0 !== e.forcePage && console.warn("(react-paginate): Both initialPage (".concat(e.initialPage, ") and forcePage (").concat(e.forcePage, ") props are provided, which is discouraged.") + " Use exclusively forcePage prop for a controlled component.\nSee https://reactjs.org/docs/forms.html#controlled-components"), a = e.initialPage ? e.initialPage : e.forcePage ? e.forcePage : 0, t.state = {
              selected: a
            }, t;
          }

          return _createClass(PaginationBoxView, [{
            key: "componentDidMount",
            value: function value() {
              var e = this.props,
                  t = e.initialPage,
                  a = e.disableInitialCallback,
                  r = e.extraAriaContext,
                  o = e.pageCount,
                  _ = e.forcePage;
              void 0 === t || a || this.callCallback(t), r && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(o) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(o, "). Did you forget a Math.ceil()?")), void 0 !== t && t > o - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(t, " > ").concat(o - 1, ").")), void 0 !== _ && _ > o - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(_, " > ").concat(o - 1, ")."));
            }
          }, {
            key: "componentDidUpdate",
            value: function value(e) {
              void 0 !== this.props.forcePage && this.props.forcePage !== e.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({
                selected: this.props.forcePage
              })), Number.isInteger(e.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
            }
          }, {
            key: "getForwardJump",
            value: function value() {
              var e = this.state.selected,
                  t = this.props,
                  a = t.pageCount,
                  r = e + t.pageRangeDisplayed;
              return r >= a ? a - 1 : r;
            }
          }, {
            key: "getBackwardJump",
            value: function value() {
              var e = this.state.selected - this.props.pageRangeDisplayed;
              return e < 0 ? 0 : e;
            }
          }, {
            key: "getElementHref",
            value: function value(e) {
              var t = this.props,
                  a = t.hrefBuilder,
                  r = t.pageCount,
                  o = t.hrefAllControls;
              if (a) return o || e >= 0 && e < r ? a(e + 1, r, this.state.selected) : void 0;
            }
          }, {
            key: "ariaLabelBuilder",
            value: function value(e) {
              var t = e === this.state.selected;

              if (this.props.ariaLabelBuilder && e >= 0 && e < this.props.pageCount) {
                var a = this.props.ariaLabelBuilder(e + 1, t);
                return this.props.extraAriaContext && !t && (a = a + " " + this.props.extraAriaContext), a;
              }
            }
          }, {
            key: "getPageElement",
            value: function value(e) {
              var t = this.state.selected,
                  a = this.props,
                  r = a.pageClassName,
                  o = a.pageLinkClassName,
                  _ = a.activeClassName,
                  n = a.activeLinkClassName,
                  i = a.extraAriaContext,
                  s = a.pageLabelBuilder;
              return react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_PageView__WEBPACK_IMPORTED_MODULE_2__.Z, {
                key: e,
                pageSelectedHandler: this.handlePageSelected.bind(null, e),
                selected: t === e,
                rel: this.getElementPageRel(e),
                pageClassName: r,
                pageLinkClassName: o,
                activeClassName: _,
                activeLinkClassName: n,
                extraAriaContext: i,
                href: this.getElementHref(e),
                ariaLabel: this.ariaLabelBuilder(e),
                page: e + 1,
                pageLabelBuilder: s,
                getEventListener: this.getEventListener
              });
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props.renderOnZeroPageCount;
              if (0 === this.props.pageCount && void 0 !== e) return e ? e(this.props) : e;
              var t = this.props,
                  a = t.disabledClassName,
                  r = t.disabledLinkClassName,
                  o = t.pageCount,
                  _ = t.className,
                  n = t.containerClassName,
                  i = t.previousLabel,
                  s = t.previousClassName,
                  l = t.previousLinkClassName,
                  p = t.previousAriaLabel,
                  c = t.prevRel,
                  d = t.nextLabel,
                  u = t.nextClassName,
                  f = t.nextLinkClassName,
                  g = t.nextAriaLabel,
                  P = t.nextRel,
                  E = this.state.selected,
                  b = 0 === E,
                  y = E === o - 1,
                  v = "".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(s)).concat(b ? " ".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(a)) : ""),
                  C = "".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(u)).concat(y ? " ".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(a)) : ""),
                  O = "".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(l)).concat(b ? " ".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(r)) : ""),
                  m = "".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(f)).concat(y ? " ".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(r)) : ""),
                  L = b ? "true" : "false",
                  h = y ? "true" : "false";
              return react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
                className: _ || n
              }, react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
                className: v
              }, react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", _extends({
                className: O,
                href: this.getElementHref(E - 1),
                tabIndex: b ? "-1" : "0",
                role: "button",
                onKeyPress: this.handlePreviousPage,
                "aria-disabled": L,
                "aria-label": p,
                rel: c
              }, this.getEventListener(this.handlePreviousPage)), i)), this.pagination(), react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
                className: C
              }, react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", _extends({
                className: m,
                href: this.getElementHref(E + 1),
                tabIndex: y ? "-1" : "0",
                role: "button",
                onKeyPress: this.handleNextPage,
                "aria-disabled": h,
                "aria-label": g,
                rel: P
              }, this.getEventListener(this.handleNextPage)), d)));
            }
          }, {
            key: "__reactstandin__regenerateByEval",
            value: function __reactstandin__regenerateByEval(key, code) {
              this[key] = eval(code);
            }
          }]), PaginationBoxView;
        }(react__WEBPACK_IMPORTED_MODULE_0__.Component),
            reactHotLoader,
            leaveModule;

        _defineProperty(PaginationBoxView, "propTypes", {
          pageCount: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number.isRequired,
          pageRangeDisplayed: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number,
          marginPagesDisplayed: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number,
          previousLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().node,
          previousAriaLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          prevPageRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          prevRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          nextLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().node,
          nextAriaLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          nextPageRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          nextRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          breakLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default().string, prop_types__WEBPACK_IMPORTED_MODULE_1___default().node]),
          hrefBuilder: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
          hrefAllControls: prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool,
          onPageChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
          onPageActive: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
          onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
          initialPage: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number,
          forcePage: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number,
          disableInitialCallback: prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool,
          containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          className: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          pageClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          pageLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          pageLabelBuilder: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
          activeClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          activeLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          previousClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          nextClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          previousLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          nextLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          disabledClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          disabledLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          breakClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          breakLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          extraAriaContext: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          ariaLabelBuilder: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
          eventListener: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
          renderOnZeroPageCount: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
          selectedPageRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string
        }), _defineProperty(PaginationBoxView, "defaultProps", {
          pageRangeDisplayed: 2,
          marginPagesDisplayed: 3,
          activeClassName: "selected",
          previousLabel: "Previous",
          previousClassName: "previous",
          previousAriaLabel: "Previous page",
          prevPageRel: "prev",
          prevRel: "prev",
          nextLabel: "Next",
          nextClassName: "next",
          nextAriaLabel: "Next page",
          nextPageRel: "next",
          nextRel: "next",
          breakLabel: "...",
          disabledClassName: "disabled",
          disableInitialCallback: !1,
          pageLabelBuilder: function pageLabelBuilder(e) {
            return e;
          },
          eventListener: "onClick",
          renderOnZeroPageCount: void 0,
          selectedPageRel: "canonical",
          hrefAllControls: !1
        }), reactHotLoader = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0, reactHotLoader && reactHotLoader.register(PaginationBoxView, "PaginationBoxView", "/home/yoan/work/oss/react-paginate/react_components/PaginationBoxView.js"), leaveModule = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0, leaveModule && leaveModule(module);
      },
      351: function _(e, t, a) {
        "use strict";

        a.r(t), a.d(t, {
          default: function _default() {
            return n;
          }
        });
        var r,
            o = a(214);
        e = a.hmd(e), (r = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r(e), "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature;
        var _ = o.Z;
        var n = _;
        var i, s;
        (i = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && i.register(_, "default", "/home/yoan/work/oss/react-paginate/react_components/index.js"), (s = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && s(e);
      },
      923: function _(e, t, a) {
        "use strict";

        var r, o, _;

        function n(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
          return null != e ? e : t;
        }

        a.d(t, {
          m: function m() {
            return n;
          }
        }), e = a.hmd(e), (r = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r(e), "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature, (o = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && o.register(n, "classNameIfDefined", "/home/yoan/work/oss/react-paginate/react_components/utils.js"), (_ = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && _(e);
      },
      703: function _(e, t, a) {
        "use strict";

        var r = a(414);

        function o() {}

        function _() {}

        _.resetWarningCache = o, e.exports = function () {
          function e(e, t, a, o, _, n) {
            if (n !== r) {
              var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw i.name = "Invariant Violation", i;
            }
          }

          function t() {
            return e;
          }

          e.isRequired = e;
          var a = {
            array: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            elementType: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t,
            checkPropTypes: _,
            resetWarningCache: o
          };
          return a.PropTypes = a, a;
        };
      },
      697: function _(e, t, a) {
        e.exports = a(703)();
      },
      414: function _(e) {
        "use strict";

        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },
      98: function _(e) {
        "use strict";

        e.exports = __WEBPACK_EXTERNAL_MODULE__98__;
      }
    },
        __webpack_module_cache__ = {};

    function __webpack_require__(e) {
      var t = __webpack_module_cache__[e];
      if (void 0 !== t) return t.exports;
      var a = __webpack_module_cache__[e] = {
        id: e,
        loaded: !1,
        exports: {}
      };
      return __webpack_modules__[e](a, a.exports, __webpack_require__), a.loaded = !0, a.exports;
    }

    __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return __webpack_require__.d(t, {
        a: t
      }), t;
    }, __webpack_require__.d = function (e, t) {
      for (var a in t) {
        __webpack_require__.o(t, a) && !__webpack_require__.o(e, a) && Object.defineProperty(e, a, {
          enumerable: !0,
          get: t[a]
        });
      }
    }, __webpack_require__.hmd = function (e) {
      return (e = Object.create(e)).children || (e.children = []), Object.defineProperty(e, "exports", {
        enumerable: !0,
        set: function set() {
          throw new Error("ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: " + e.id);
        }
      }), e;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };

    var __webpack_exports__ = __webpack_require__(351);

    return __webpack_exports__;
  }();
});